import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Copy } from './copy.js';
import { Text } from './text.js';
import { good, fair, poor } from './theme.js';
const getPasswordScoreDefinition = (value, requiredScore) => {
    if (value >= requiredScore) {
        return {
            label: 'Strong',
            color: good,
        };
    }
    else if (value === 0) {
        return {
            label: 'Weak',
            color: poor,
        };
    }
    else if (value < requiredScore) {
        return {
            label: 'Fair',
            color: fair,
        };
    }
    else {
        return {
            label: 'Weak',
            color: poor,
        };
    }
};
const StyledPasswordMeterSection = styled.div.withConfig({ displayName: "brc-StyledPasswordMeterSection", componentId: "brc-s6hwbr" }) `
  display: grid;
  grid-gap: 8px;
`;
const StyledProgress = styled.progress.withConfig({ displayName: "brc-StyledProgress", componentId: "brc-budny" }) `
  appearance: none;
  &::-webkit-progress-bar {
    background-color: ${({ theme }) => theme.neutral100};
    border-radius: 12px;
  }
  &::-webkit-progress-value {
    border-radius: 12px;
    background-color: ${({ value, max }) => getPasswordScoreDefinition(value, max).color};
  }
  height: 8px;
  width: 100%;
`;
export const PasswordStrengthMeter = ({ requiredPasswordScore, passwordStrengthScore, className }) => {
    return (_jsxs(StyledPasswordMeterSection, Object.assign({ className: className }, { children: [_jsx(StyledProgress, { max: requiredPasswordScore, value: passwordStrengthScore }), _jsxs(Copy, Object.assign({ size: "sm" }, { children: ["Password strength:", ' ', _jsx(Text, Object.assign({ "$bold": true }, { children: getPasswordScoreDefinition(passwordStrengthScore, requiredPasswordScore).label }))] }))] })));
};
const StyledPasswordStrengthMeter = styled(PasswordStrengthMeter).withConfig({ displayName: "brc-StyledPasswordStrengthMeter", componentId: "brc-t4jn4i" }) ``;
export default StyledPasswordStrengthMeter;
//# sourceMappingURL=password-strength-meter.js.map